import React from 'react';
import PropTypes from 'prop-types';
import { getNumericInputAttrs } from '../../../../utils';

export default function InputNumericVanWestendorp({
  min,
  max,
  answerId,
  decimals = 0,
}) {
  const { inputMode, pattern, step } = getNumericInputAttrs(decimals);

  if (Pollfish.helper.json.sdk_version < 17 && Pollfish.helper.isAndroid()) {
    return (
      <textarea
        rows="1"
        data-answer-id={answerId}
        className="input-text input-van-westendorp"
        aria-label="numeric value"
      ></textarea>
    );
  }

  return (
    <div className="form-container text-center">
      <input
        data-answer-id={answerId}
        className="input-text input-van-westendorp"
        type="number"
        min={min}
        max={max}
        inputMode={inputMode}
        pattern={pattern}
        step={step}
        aria-label="numeric value"
      />
    </div>
  );
}

InputNumericVanWestendorp.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  answerId: PropTypes.number,
  decimals: PropTypes.number,
};
